import React from 'react';

import {profileTabSeparator} from './profile-tab-separator.module.styl';

export const ProfileTabSeparator = () => (
    <div className={profileTabSeparator}/>
);
